<div *ngIf="isSignupCompleted" class="amplify-success-message">
  <img src="assets/images/circled-check.png" alt="Success" class="icon"/>
  <span class="text">Account creation successful! Log in to get started with Fitness Passport.</span>
</div>